import { render, staticRenderFns } from "./Clips.vue?vue&type=template&id=2163fa30&scoped=true&"
import script from "./Clips.vue?vue&type=script&lang=js&"
export * from "./Clips.vue?vue&type=script&lang=js&"
import style0 from "./Clips.vue?vue&type=style&index=0&id=2163fa30&lang=scss&scoped=true&"
import style1 from "./Clips.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163fa30",
  null
  
)

export default component.exports